<div class="sidenav-header">
  <div class="sidenav-header-title">
    <div class="sidenav-header-title-logo"
      (click)="toggleNavBar.emit()"
      (keypress)="toggleNavBar.emit()">
      <img
        src="{{ logoUrl }}"
        title="{{'APP.TOOLTIPS.COLLAPSE_NAVIGATION' | translate}}"
        alt="{{ 'CORE.HEADER.LOGO_ARIA' | translate }}" />
    </div>

    <ng-container *ngFor="let actionRef of actions; trackBy: trackByActionId">
      <aca-toolbar-action [actionRef]="actionRef"></aca-toolbar-action>
    </ng-container>
  </div>
</div>
